





















































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ModalComponent from '@/shared/modal/modal.component.vue'
import BusinessUnitStore from '@/domain/business-unit/service/business-unit.store'
import ContractService from '@/domain/contract/service/contract.service';
import ModalOptions from '../../../../../shared/modal/modal-options.entity';
import ContractItem from '../../../../../domain/contract/entity/contract-item.entity';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
  },
})
export default class EditObservationModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true, default: '' })
  businessUnitId!: string;

  @Prop({ required: true })
  item!: ContractItem;

  private iconToolTip = 'Clique na "Macro" para adicionar';

  private macros: string[] = [];

  private observation: string = '';

  created() {
    this.updateItemObservation();
    this.getMacros();
  }

  @Watch('show')
  updateItemObservation() {
    this.observation = this.item.hasCustomMacros
      ? this.item.observation
      : '';
  }

  get options(): ModalOptions {
    return {
      title: 'Editar Observação do Item de Contrato',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 1024,
      persistent: false,
    }
  }

  @Emit('ok')
  private ok(): any {
    return { id: this.item.id, observation: this.observation };
  }

  @Emit('cancel')
  private cancel(): void {}

  @Watch('show')
  getMacros() {
    if (this.businessUnitId && this.show === true) {
      ContractService.getMacros(this.businessUnitId, this.item.id)
        .then((response) => {
          this.macros = response;
          this.$forceUpdate();
        })
        .catch((error: any) => {
          VbSnackbarService.handleHttpError(error);
        });
    }
  }

  insertMacro(macro: string) {
    const observationInput = document.getElementById('observation-input') as any;

    const startPos = observationInput.selectionStart;
    const endPos = observationInput.selectionEnd;
    observationInput.value = observationInput.value.substring(0, startPos)
      + macro
      + observationInput.value.substring(endPos, observationInput.value.length);
    this.observation = observationInput.value;
    observationInput.focus();

    const macroLength = macro.length;
    observationInput.setSelectionRange(startPos + macroLength, startPos + macroLength);
  }
}
